import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHeader, TableRow, Modal, Header } from 'semantic-ui-react';
import getVerifiedCompanyRecruiters from '../../../../../services/getVerifiedCompanyRecruiters';
import getUnmappedRecruiters from '../../../../../services/getUnmappedRecruitersByDomain';
import Button from '../../../../../components/Button';
import  CompanyDropdown  from '../../../../../components/Dropdown/CompanyDropdown';
import updateCompanyId from '../../../../../services/updateCompanyId';
import { getValueFromRecruiterType } from '../../../../../models/recruiterType';
import { toast } from 'react-toastify';
import './CompanyStyles.scss';

const notAvailable = 'N/A';

const CompanySingleList = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [isViewingRecruiters, setIsViewingRecruiters] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({id: props.data.id, name: props.data.name});
    const [recruiters, setRecruiters] = useState({ iimjobs: [], hirist: [] });
    const [unmappedRecruiters, setUnmappedRecruiters] = useState({ iimjobs: [], hirist: [] });
    const [submitLoading, setSubmitLoading] = useState(false);
    const [mappingLoading, setMappingLoading] = useState(false);
    const [showUnmapped, setShowUnmapped] = useState(false);

    
    const companyId = props.data.id;
    const status = props.data.status;
    const onInactiveClick = async() => {
        const list = await fetchRecruiters(companyId);
        if (!list) {
            return; 
        }
        setRecruiters(list);
        if(list && (list.iimjobs.length || list.hirist.length) > 0) {
            setModalOpen(true);
        } else {
            const userConfirm = confirm('Are you sure you want to perform this action?');
            if (userConfirm) {
                props.changeStatus();
            }
        }
    };
    const onViewRecruitersClick = async() => {
        const list = await fetchRecruiters(companyId);
        const list2 = await fetchUnmappedRecruiters();
        setRecruiters(list);
        setUnmappedRecruiters(list2);
        setIsViewingRecruiters(true);
        setModalOpen(true);
    };
    const onActivateClick = () => {
        const userConfirm = confirm('Are you sure you want to perform this action?');
        if (userConfirm) {
            props.changeStatus();
        }
    };
    const fetchRecruiters = async (companyId) => {
        try {
            const recruitersList = await getVerifiedCompanyRecruiters(props.adminId, {companyId});
            return recruitersList.data.data;
        } catch (error) {
            console.error('Failed to fetch recruiters:', error);
            toast.error('Failed to fetch recruiters data');
            return { iimjobs: [], hirist: [] };
        }
    };
    const fetchUnmappedRecruiters = async () => {
        try {
            const recruitersList = await getUnmappedRecruiters(props.adminId, {domains: props.data.domains.join(',')});
            return recruitersList.data.data;
        } catch (error) {
            console.error('Failed to fetch Unmapped Recruiters:', error);
            toast.error('Failed to fetch Unmapped Recruiters data');
            return { iimjobs: [], hirist: [] };
        }
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setIsViewingRecruiters(false);
        setShowUnmapped(false);
    };

    const handleModalSubmit = async () => {
        try {
            setSubmitLoading(true);
            if(selectedCompany.id==companyId)
            {
                toast.error('Select a different company');
                setSubmitLoading(false);
                return;
            }
            const recruiterIds = {
                iimjobs: recruiters.iimjobs.map((recruiter) => recruiter.id),
                hirist: recruiters.hirist.map((recruiter) => recruiter.id),
            };
            await updateCompanyId(props.adminId, {companyId:selectedCompany.id, recruiterIds,adminEmail:props.adminEmail});
            toast.success('Recruiters mapped successfully');
            props.changeStatus();
            setSubmitLoading(false);
            handleModalClose();
        } catch(err){
            console.error('Failed to map recruiters to company',err);
            toast.error('Failed to map recruiters to company');
            setSubmitLoading(false);
            handleModalClose();
        }
    };
    const handleModalMapping = async () => {
        try {
            setMappingLoading(true);
            const recruiterIds = {
                iimjobs: unmappedRecruiters.iimjobs.map((recruiter) => recruiter.id),
                hirist: unmappedRecruiters.hirist.map((recruiter) => recruiter.id),
            };
            await updateCompanyId(props.adminId, {companyId:companyId, recruiterIds,adminEmail:props.adminEmail});
            toast.success('Recruiters mapped successfully');
            setMappingLoading(false);
            handleModalClose();
        } catch(err){
            console.error('Failed to map recruiters to company',err);
            toast.error('Failed to map recruiters to company');
            setMappingLoading(false);
            handleModalClose();
        }
    };

    
    return (
        <>
            <TableRow>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.id ? props.data.id : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {(props.data.domains || []).join(',')}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.name ? props.data.name : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.displayName ? props.data.displayName : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {Number(props.data.type)
                        ? getValueFromRecruiterType(props.data.type)
                        : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.industry
                        ? props.industryData[props.data.industry]
                        : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.infoedgeId ? props.data.infoedgeId : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.naukriCompanyId ? props.data.naukriCompanyId : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.naukriGroupName ? props.data.naukriGroupName : notAvailable}
                </Table.Cell>
                <Table.Cell className="managementData" verticalAlign="top">
                    {props.data.moderated ? 'true' : 'false'}
                </Table.Cell>
                {props.executeAccess ? (
                    <Table.Cell className="managementData actions" verticalAlign="top">
                        {
                            <Button
                            skin="dark"
                            text="View Recruiters"
                            clickButton={onViewRecruitersClick}
                            className="buttonMargin"
                        />
                        }
                        {props.data.status == 1 && (
                            <Button 
                                skin="dark" 
                                text="Inactive" 
                                clickButton={onInactiveClick} 
                                className="buttonMargin" 
                            />
                        )}
                        {props.data.status == 0 && (
                            <Button
                                skin="dark"
                                text="Activate"
                                clickButton={onActivateClick}
                                className="buttonMargin"
                            />
                        )}
                        {props.data.status == 1 && (
                            <Button
                            skin="dark"
                            text="Edit"
                            clickButton={props.onClick}
                            className="buttonMargin"
                            />
                        )}
                        
                    </Table.Cell>
                ) : null}
            </TableRow>

            <Modal open={modalOpen} onClose={handleModalClose} size="fullscreen">
                {(
                    <>
                        <Header content={props.data.name} />
                        {(
                            <>
                               {isViewingRecruiters && (
                                    <div className="modal-tabs">
                                    <Button
                                        skin="dark"
                                        text={showUnmapped ? "Show Mapped Recruiters" : "Show Unmapped Recruiters"}
                                        clickButton={() => setShowUnmapped(!showUnmapped)}
                                        className="buttonMargin tabButton"
                                    />
                                     </div>
                                )}
                                <Modal.Content scrolling>
                                    {!showUnmapped ? (
                                        <>
                                            {!isViewingRecruiters && (
                                                <div className="companyDropdown">
                                                    <div>Select the new company to map the recruiters: </div>
                                                    <CompanyDropdown
                                                        adminId={props.adminId}
                                                        selectedCompany={selectedCompany.name}
                                                        onCompanySelect={(id, label) => setSelectedCompany({id, name: label})}
                                                    />
                                                </div>
                                            )}
                                            <RecruiterTable title="IIMJOBS-Mapped" recruiters={recruiters.iimjobs} />
                                            <RecruiterTable title="HIRIST-Mapped" recruiters={recruiters.hirist} />
                                            {recruiters.iimjobs.length === 0 && 
                                            recruiters.hirist.length === 0 && (
                                                <div>No recruiters found</div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {isViewingRecruiters && status === 1 && 
                                            (unmappedRecruiters.iimjobs.length > 0 || unmappedRecruiters.hirist.length > 0) && (
                                                <div className='companyDropdown'>
                                                    <div>Do you want map the Unmapped recruiters to current company </div>
                                                    <Button
                                                        clickButton={handleModalMapping}
                                                        skin="light"
                                                        text="Yes"
                                                        loading={mappingLoading}
                                                    />
                                                </div>
                                            )}
                                            <RecruiterTable title="IIMJOBS-Unmapped" recruiters={unmappedRecruiters.iimjobs} />
                                            <RecruiterTable title="HIRIST-Unmapped" recruiters={unmappedRecruiters.hirist} />
                                            {unmappedRecruiters.iimjobs.length === 0 && unmappedRecruiters.hirist.length === 0 && (
                                                 <div>No recruiters found</div>
                                            )}
                                        </>
                                    )}
                                </Modal.Content>
                                <Modal.Actions>
                                    {!isViewingRecruiters && (
                                        <Button
                                            clickButton={handleModalSubmit}
                                            skin="light"
                                            text="Submit"
                                            loading={submitLoading}
                                        />
                                    )}
                                    <Button
                                        clickButton={handleModalClose}
                                        skin="light"
                                        text="Close"
                                    />
                                </Modal.Actions>
                            </>
                        )}
                    </>
                )}
            </Modal>
        </>
    );
};

const RecruiterTable = ({ title, recruiters }) => {
    if (recruiters.length === 0) return null;

    return (
        <Table fixed selectable>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan='4'>{title}</Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                    <Table.HeaderCell width={3}>Recruiter Id</Table.HeaderCell>
                    <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                    <Table.HeaderCell width={5}>Email</Table.HeaderCell>
                    <Table.HeaderCell width={4}>Recruiter Status</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {recruiters.map((recruiter) => (
                    <Table.Row key={recruiter.id}>
                        <Table.Cell>{recruiter.id}</Table.Cell>
                        <Table.Cell>{recruiter.recname}</Table.Cell>
                        <Table.Cell>{recruiter.email}</Table.Cell>
                        <Table.Cell>{recruiter.status === 1 ? 'Active' : 'Inactive'}</Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

CompanySingleList.propTypes = {
    data: PropTypes.object,
    industryData: PropTypes.array,
    executeAccess: PropTypes.bool,
    changeStatus: PropTypes.func,
    onClick: PropTypes.func,
    adminId: PropTypes.string.isRequired,
    adminEmail: PropTypes.string.isRequired,
};

export default CompanySingleList;
